module.exports = __webpack_public_path__ + "media/img/pages/companies/lgt-pb-287da42bafbc03826bf163a540a23268.png";